import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=436e8706"
import script from "./ReLogin.vue?vue&type=script&lang=js"
export * from "./ReLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports